






















import { CampaignsViewModel } from '@/types/contentServerContract';
import { Component, Prop, Vue } from 'vue-property-decorator';
import CampaignTeaser from '@/project/app/content-pages/CampaignTeaser.vue';
import SmartHeadline from '@/core/ui-components/SmartHeadline.vue';

@Component({
    components: { CampaignTeaser, SmartHeadline }
})
export default class LatestCampaignsBlock extends Vue {
    @Prop({
        required: true,
        type: Object
    }) content!: CampaignsViewModel;

    @Prop({
        required: false,
        default: false,
        type: Boolean
    }) isFirstBlock!: boolean;

    private get campaigns() {
        if (!this.content.firstCampaign) {
            return [...this.content.campaigns];
        }
        return [this.content.firstCampaign, ...this.content.campaigns];
    }

    private get anyCampaignWithImageOrIcon(): boolean {
        return !!this.campaigns.find(c => c.image?.url || (c.showIcon && c.iconUrl));
    }

    private get id() {
        return 'latest-campaigns-block-' + new Date().valueOf();
    }

    private get prevButtonSelector() {
        return 'custom-swiper-button-prev-' + this.id;
    }

    private get nextButtonSelector() {
        return 'custom-swiper-button-next-' + this.id;
    }

    private get sliderOptions() {
        return {
            spaceBetween: 20,
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            loop: false,
            loopFillGroupWithBlank: false,
            watchSlidesVisibility: true,
            watchOverflow: true,
            setWrapperSize: false,
            autoHeight: false,
            navigation: {
                nextEl: '.' + this.nextButtonSelector,
                prevEl: '.' + this.prevButtonSelector
            },
            grabCursor: true,
            instanceName: this.id,
            observer: true,
            observeParents: true,
            observeSlideChildren: true
        };
    }
}
